import { apiMainUrl } from "../../components/Helpers/Config";
import {
  LOGIN_SUCCESS,
  LOGIN_GUEST_SUCCESS,
  LOGIN_FAILED,
  LOGIN_GOOGLE_FAILED,
  LOGOUT_SUCCESSFUL,
  USER_LOADING,
  USER_LOADED,
  USER_LOAD_AVATAR,
  USER_LOAD_COVER,
  USER_LOAD_PINNED,
  AUTHENTICATION_ERROR,
  AUTHENTICATION_PUBLIC_ERROR,
  AUTHENTICATION_PUBLIC_FAILED,
  UPDATE_PROFILE,
  GET_USER_THEME,
  GET_THEME_LOADER,
  GET_USER_DEFAULT_THEME,
  USER_PUBLIC_LOADING,
  USER_PUBLIC_LOADED,
  GET_IMAGE_POOLS,
  GET_SYSTEM_THEMES,
  GET_VBE_LISTS,
  USER_LOADING_FALSE,
  GET_ANALYTICS_LISTS,
  GET_MENU_ITEMS,
  GET_COMMUNITY_SUBMENU_ITEMS,
} from "../actions/auth";

const initialState = {
  token: localStorage.getItem("dp2_token_access"),
  token_refresh: localStorage.getItem("dp2_token_refresh"),
  isLoading: true,
  isAuthenticated: false,
  isPublicAuth: true,
  isPublicLoading: false,
  publicToken: null,
  user: null,
  error: null,
  theme: "",
  systemTheme: [],
  isDefaultTheme: false,
  isThemeLoader: true,
};

const setToken = (data) => {
  localStorage.setItem("dp2_token_access", data.token);
  localStorage.setItem("dp2_token_refresh", data.refreshToken);
  localStorage.setItem("dp2_gsuite_user_id", data.gsuite_user_id);
  localStorage.setItem("user_id", data.reference_id);
};

const setTokenGuest = (token, data) => {
  // localStorage.setItem("dp2_token_access", token);
  // localStorage.setItem("dp2_token_refresh", token);
  // localStorage.setItem("dp2_gsuite_user_id", data.user_gid);
  localStorage.setItem("dp2_token_access", token);
  localStorage.setItem("dp2_token_access_" + data.link, token);
  localStorage.setItem("dp2_token_refresh_" + data.link, token);
  localStorage.setItem("dp2_gsuite_user_id_" + data.link, data.user_gid);
  localStorage.setItem("useraccess", data.link);
};

const clearToken = () => {
  var isRemove = localStorage.getItem("useraccess");
  if (isRemove === undefined || isRemove === null || isRemove === "") {
    localStorage.removeItem("dp2_token_access");
  }
  localStorage.removeItem("dp2_token_refresh");
  localStorage.removeItem("dp2_gsuite_user_id");
  localStorage.removeItem("idleTime");
  localStorage.removeItem("user_id");
};

const clearPublicToken = (userCode) => {
  localStorage.removeItem("dp2_token_access");
  localStorage.removeItem("useraccess");
  localStorage.removeItem("dp2_token_access_" + userCode);
  localStorage.removeItem("dp2_token_refresh_" + userCode);
  localStorage.removeItem("dp2_gsuite_user_id_" + userCode);
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_LOADING:
      return {
        ...state,
        error: null,
        isLoading: true,
      };
    case USER_LOADING_FALSE:
      return {
        ...state,
        error: null,
        isLoading: false,
      };
    case USER_LOADED:
      return {
        ...state,
        error: null,
        isAuthenticated: true,
        isLoading: false,
        user: {
          ...action.user,
          gsuite_user_id: action.user.gid,
        },
      };
    case USER_PUBLIC_LOADING:
      return {
        ...state,
        isPublicLoading: true,
      };
    case USER_PUBLIC_LOADED:
      return {
        ...state,
        error: null,
        isPublicLoading: false,
        isPublicAuth: true,
        publicToken: {
          token: action.data.token,
          acces_type: action.data.acces_type,
          iat: action.data.iat,
          link: action.data.link,
          user_id_access: action.data.user_id_access,
          user_gid: action.data.gid,
        },
      };
    case USER_LOAD_AVATAR:
      return {
        ...state,
        error: null,
        user: {
          ...state.user,
          photo: action.payload.photo,
        },
      };
    case USER_LOAD_COVER:
      return {
        ...state,
        error: null,
        user: {
          ...state.user,
          cover: action.payload.cover,
        },
      };
    case USER_LOAD_PINNED:
      return {
        ...state,
        error: null,
        user: {
          ...state.user,
          pinned_reflection_image: action.payload.pinned_reflection_image,
        },
      };
    case LOGIN_SUCCESS:
      setToken(action.data);

      return {
        ...state,
        user: {
          cover: action.data.cover,
          email: action.data.email,
          display_email: action.data.display_email,
          secondary_email: action.data.secondary_email,
          fullname: action.data.name,
          photo: action.data.profile_image,
          programme: action.data.programme,
          role: action.data.user_type,
          gsuite_user_id: action.data.gsuite_user_id,
          gid: action.data.gsuite_user_id,
          matric: action.data.matric,
          user_id: action.data.reference_id,
          user_type: action.data.user_type,
          role: action.data.role,
          pinned_reflection_image: action.data.pinned_reflection_image,
          guid: action.data.guid ? action.data.guid : "",
          programme_category: action.data.programme_category
            ? action.data.programme_category
            : "",
        },
        theme: action.data?.themes,
        isAuthenticated: true,
        isLoading: false,
        error: null,
      };
    case LOGIN_GUEST_SUCCESS:
      setTokenGuest(action.token, action.data);
      return {
        ...state,
        publicToken: {
          token: action.token,
          acces_type: action.data.acces_type,
          iat: action.data.iat,
          link: action.data.link,
          user_id_access: action.data.user_id_access,
          user_gid: action.data.user_gid,
        },
        isPublicLoading: false,
        error: null,
      };
    case UPDATE_PROFILE:
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
        },
      };
    case LOGIN_GOOGLE_FAILED:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case LOGIN_FAILED:
      clearToken();
      return {
        ...state,
        user: null,
        isAuthenticated: false,
        isLoading: false,
        error: action.error,
      };
    case AUTHENTICATION_ERROR:
      clearToken();
      return {
        ...state,
        errors: action.error,
        token_access: null,
        token_refresh: null,
        user: null,
        isAuthenticated: false,
        isLoading: false,
      };
    case AUTHENTICATION_PUBLIC_FAILED:
      clearPublicToken(action.data);
      return {
        ...state,
        isPublicAuth: false,
        publicToken: null,
        isPublicLoading: false,
      };
    case AUTHENTICATION_PUBLIC_ERROR:
      clearPublicToken(action.data);
      return {
        ...state,
        isPublicAuth: false,
        publicToken: null,
        isPublicLoading: false,
      };
    case LOGOUT_SUCCESSFUL:
      clearToken();
      return {
        ...state,
        token_access: null,
        token_refresh: null,
        isAuthenticated: false,
        isLoading: false,
        user: null,
        error: null,
      };
    case GET_USER_THEME:
      return {
        ...state,
        theme: action.payload,
        isDefaultTheme: false,
      };
    case GET_THEME_LOADER:
      return {
        ...state,
        isThemeLoader: action.payload,
      };
    case GET_USER_DEFAULT_THEME:
      return {
        ...state,
        isDefaultTheme: true,
      };
    case GET_IMAGE_POOLS:
      return {
        ...state,
        imagePool: action.payload,
      };
    case GET_SYSTEM_THEMES:
      return {
        ...state,
        systemTheme: action.payload,
      };
    case GET_VBE_LISTS:
      return {
        ...state,
        vbeLists: action.payload,
      };
    case GET_ANALYTICS_LISTS:
      return {
        ...state,
        analyticsList: action.payload,
      };
    case GET_MENU_ITEMS:
      return {
        ...state,
        menu_items: action.payload,
      };
    case GET_COMMUNITY_SUBMENU_ITEMS:
      return {
        ...state,
        community_submenu: action.payload,
      };
    default:
      return state;
  }
};

export default authReducer;
